export function UserListTable({ users }) {
  if (users.length === 0) {
    return <p className="py-6 text-center text-slate-400">No users found.</p>;
  }

  return (
    <div className="overflow-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="border-b text-left text-slate-500">
            <th className="py-2 pr-4">Name</th>
            <th className="py-2 pr-4">Email</th>
            <th className="py-2 pr-4">Role</th>
            <th className="py-2">Active</th>
          </tr>
        </thead>
        <tbody>
          {users.map((row) => (
            <tr key={row.id || row.email} className="border-b border-slate-100">
              <td className="py-2 pr-4">{row.name}</td>
              <td className="py-2 pr-4">{row.email}</td>
              <td className="py-2 pr-4 capitalize">
                {String(row.role || '').replace(/_/g, ' ')}
              </td>
              <td className="py-2">{row.is_active === false ? 'No' : 'Yes'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
